// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3SC_W","rootSmall":"AddTileButton_rootSmall__3GqFV"};